const Actividad = props => {

    const state = props.state;
    return(
        <>
        <h5>Actividad</h5>
        <span className="fst-italic">Selecciona el tipo de actividad a la que quisieras asistir</span>
        <div className="mt-2 mb-2">
            <div className="row g-1">
                <div className="col-md-12">
                    <div className="mb-1">
                        <label htmlFor="actividad-charla" className="form-label text-primary">Seleccione Actividad <span className="text-dark fst-italic ms-1">(Obligatorio)</span></label>
                        <select className="form-select form-select-sm" id="actividad-charla" name="actividad" value={state.actividad} onChange={e => props.handleOnChangeText(e)}>
                            <option value="">Seleccione una actividad</option>
                            {
                                props.actividadesAdmision.map((row,index) => {
                                    return(
                                        <option key={index} value={row.id}>{row.nombre}</option>
                                    )
                                })
                            }
                        </select>
                        <div className="text-danger invalid-text text-start">{props.error.actividad}</div>
                    </div>
                </div>
                {props.stateEncontrado ? 
                    <div className="col-12 col-md-12">
                        <div className="mb-2">
                            <label htmlFor="cantidad_visitantes" className="form-label text-primary">Señale la cantidad aproximada de visitantes que participarán en la actividad. <span className="text-dark fst-italic ms-1">(Obligatorio)</span></label>
                            <input maxLength={3} type="text" className="form-control form-control-sm" id="cantidad_visitantes" name="cantidad_visitantes" value={state.cantidad_visitantes} onChange={e => props.handleChangeSoloNum(e)}/>
                        </div>
                        <div className="text-danger invalid-text text-start">{props.error.cantidad_visitantes}</div>
                    </div>
                    : ""
                }
                <div className="col-12 col-md-12">
                    <label htmlFor="fecha_inicio" className="form-label text-primary" >Seleccione día y horario de Inicio<span className="text-dark fst-italic ms-1">(Obligatorio)</span></label>
                </div>
                <div className="col-6 col-md-6">
                    <input type="date" className="form-control form-control-sm" id="fecha_inicio" name="fecha_inicio" value={state.fecha_inicio} onChange={e => props.handleOnChangeText(e)}/>
                    <div className="text-danger invalid-text text-start">{props.error.fecha_inicio}</div>      
                </div>
                <div className="col-6 col-md-6">
                    <input type="time" className="form-control form-control-sm" id="horario_inicio" name="horario_inicio" value={state.horario_inicio} onChange={e => props.handleOnChangeText(e)}/>
                    <div className="text-danger invalid-text text-start">{props.error.horario_inicio}</div>
                </div>
                <div className="col-12 col-md-12 mt-2">
                    <label htmlFor="fecha_termino" className="form-label text-primary" >Seleccione día y horario de Término<span className="text-dark fst-italic ms-1">(Obligatorio)</span></label>
                </div>
                <div className="col-6 col-md-6">
                    <input type="date" className="form-control form-control-sm" id="fecha_termino" name="fecha_termino" value={state.fecha_termino} onChange={e => props.handleOnChangeText(e)}/>
                    <div className="text-danger invalid-text text-start">{props.error.fecha_termino}</div>      
                </div>
                <div className="col-6 col-md-6">
                    <input type="time" className="form-control form-control-sm" id="horario_termino" name="horario_termino" value={state.horario_termino} onChange={e => props.handleOnChangeText(e)}/>
                    <div className="text-danger invalid-text text-start">{props.error.horario_termino}</div>
                </div>
            </div>
        </div>
        </>

    )

}

export default Actividad;